<template>
  <div class="c-videoPlayer" >
    <transition name="fade">
      <div class="c-videoPlayer__holder" @click="playVideo" v-if="!isPlaying">
        <div class="background">
          <img :src="thumbnail" alt="Video Thumbnail" />
        </div>
		    <div class="content__play">
          <!-- <span class="o-loader o-loader--light" v-if="isBuffering"></span> -->
          <!-- <PlayIcon v-else></PlayIcon> -->
          <svg width="29" height="40" viewBox="0 0 29 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6223 17.5661C29.2838 18.7633 29.2838 21.2366 27.6223 22.4339L4.75385 38.9126C2.76953 40.3425 0 38.9245 0 36.4787L0 3.52124C0 1.07541 2.76954 -0.342562 4.75386 1.08732L27.6223 17.5661Z" fill="#58968A"/>
          </svg>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="c-videoPlayer__player">
        <youtube
          :video-id="id"
          @playing="playing"
          @paused="paused"
          width="100%"
          height="100%"
          ref="youtube"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import {YouTube} from "vue-youtube";
// import PlayIcon from "@/assets/icon/play.svg";

export default {
  name: "VideoPlayer",
  components: {
    YouTube,
  },
  mixins: [],
  props: {
    id: String,
    thumbnail: String,
  },
  data: () => {
    return {
      isPlaying: false,
      isBuffering: false,
      currentState: -1,
    };
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    }
  },
  watch: {},
  methods: {
    playVideo() {
      this.player.playVideo()
    },
    playing() {
      this.isPlaying = true;
    },
    paused() {
      this.isPlaying = false;
      this.player.pauseVideo()
    },
  },
  created() {},
  beforeMount() {},
  mounted() {},
};
</script>

<style lang="scss">

.c-videoPlayer {
  &::after {
    padding-bottom: 56%;
    display: block;
    content: "";
  }
  position: relative;

  margin: 0 auto;
  width: 100%;

  cursor: pointer;
  pointer-events: all;
  overflow: hidden;
  isolation: isolate;

  &__holder {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 4;

    .background {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: -1;
      background-color: grey;

      img {
        opacity: 0.5;
      }
    }

    .content {
      position: absolute;
      width: 100%;
      display: flex;
      align-items: center;
      padding-left: 60px;
      padding-right: 60px;

      bottom: 60px;

      &__info {
        padding-right: 60px;
        flex: 1;
        h2 {
          font-size: 30px;
          line-height: 30px;
          font-weight: 600;
          text-transform: uppercase;
          margin-bottom: 7px;
          color: tan;
        }

        p {
          color: white;
          font-size: 16px;
          line-height: 17px;
          font-weight: 400;
        }
      }

      &__play {
        position: absolute;
        top: 50%; right: 50%;
        transform: translate(50%,-50%);
        border: 2px solid white;
        background-color: white;
        width: 80px;
        height: 80px;
        border-radius: 50%;

        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          width: 23px;
          height: 30px;
          margin-left: 5px;
         
        }
      }
    }
  }

  &__player {
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;

    div {
      width: 100%;
      height: 100%;
      position: absolute !important;
    }

    iframe {
      position: absolute;
      border-radius: 10px;
      pointer-events: all;

      left: 0;
      top: 0;
    }
  }
}

@media all and (max-width: 768px) {
  .c-videoPlayer {
    &__holder {
      .content {
        padding-left: 30px;
        padding-right: 30px;
        bottom: 30px;
      }
    }
  }
}

@media all and (max-width: 600px) {
  .c-videoPlayer {
    &__holder {
      .content {
        align-items: flex-end;

        &__info {
          padding-right: 30px;

          h2 {
            font-size: 24px;
            line-height: 24px;
            margin-bottom: 3px;
          }

          p {
            font-size: 14px;
            line-height: 15px;
          }
        }

        &__play {
          width: 60px;
          height: 60px;

          svg {
            height: 25px;
            margin-left: 3px;
          }
        }
      }
    }
  }
}

@media all and (max-width: 400px) {
  .c-videoPlayer {
    &__holder {
      .content {
        align-items: flex-end;

        &__info {
          h2 {
            font-size: 22px;
            line-height: 22px;
            margin-bottom: 3px;
          }

          p {
            // @include textoverflow(2);
            font-size: 14px;
            line-height: 15px;
          }
        }

        &__play {
          width: 40px;
          height: 40px;

          svg {
            height: 16px;
            margin-left: 2px;
          }
        }
      }
    }
  }
}

@media all and (max-width: 330px) {
  .c-videoPlayer {
    &__holder {
      .content {
        align-items: flex-end;
        bottom: 20px;

        &__info {
          h1 {
            font-size: 16px;
            line-height: 16px;
            margin-bottom: 3px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// assets/_js/components/vue/VideoPlayer.vue